var _rect, _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcToggleOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 112,
    viewBox: "0 0 181 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.898438,
    width: 179.2,
    height: 112,
    rx: 56,
    fill: "#DBD6FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.8992,
    cy: 56.0008,
    r: 39.2,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_781_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1139 52.1601L64.6577 52.1601L64.6577 49.0566L63.1139 49.0566C60.2453 49.0566 57.8479 51.0413 57.1575 53.7118L55.3945 53.7118L55.3945 56.8153L57.1575 56.8153C57.8478 59.4858 60.2453 61.4705 63.1139 61.4705L64.6577 61.4705L64.6577 58.367L63.1139 58.367C61.976 58.367 60.9911 57.7387 60.4551 56.8153L64.6577 56.8153L64.6577 53.7118L60.4551 53.7118C60.991 52.7884 61.9759 52.1601 63.1139 52.1601Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.0929 68.9864L79.1 68.9864L79.1 76.6003L73.0929 76.6003L73.0929 68.9864ZM81.5 66.5864L81.5 79.0003L70.6929 79.0003L70.6929 66.5864L81.5 66.5864Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 43.2769L44.3071 43.2769L44.3071 30.863L33.5 30.863L33.5 43.2769Z",
    fill: "#7663EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8742 77.8143C55.9998 77.5847 53.2178 76.7236 51.5443 75.8577L48.0289 74.0407C46.0219 73.0008 44.447 70.4079 44.447 68.1379C44.447 66.015 45.8551 64.4744 47.7956 64.4744C48.3359 64.4744 48.8888 64.5952 49.4368 64.8311L54.567 67.0409C55.8207 67.5809 58.1503 67.9256 59.6355 67.7143L64.3275 67.0409C66.9844 66.6544 69.1489 68.6436 69.1489 71.2413L69.1489 74.3448C69.1489 75.5179 68.712 76.6041 67.92 77.4063C67.1281 78.2071 66.0598 78.6463 64.9095 78.6463C64.7272 78.6463 64.5404 78.6356 64.3522 78.612L57.8742 77.8143ZM66.2129 75.7194C65.8839 76.0518 65.4356 76.2463 64.9095 76.2463C64.8209 76.2463 64.7339 76.241 64.6503 76.2306L64.6455 76.23L58.166 75.4321C56.5755 75.2373 54.068 74.4613 52.6472 73.7261L49.133 71.9097C49.1328 71.9096 49.1331 71.9098 49.133 71.9097C48.5987 71.6327 48.0031 71.0733 47.5369 70.3053C47.0708 69.5374 46.847 68.7475 46.847 68.1379C46.847 67.6089 47.0177 67.2905 47.1651 67.1292C47.3008 66.9807 47.493 66.8744 47.7956 66.8744L47.8069 66.8744C47.9839 66.876 48.2109 66.9164 48.4873 67.0353C48.4875 67.0354 48.4871 67.0352 48.4873 67.0353L53.6175 69.2451C54.512 69.6304 55.6382 69.8926 56.6873 70.0369C57.7381 70.1815 58.9324 70.2385 59.9735 70.0904L59.9765 70.0899L64.673 69.4159C65.825 69.2483 66.7489 70.0482 66.7489 71.2413L66.7489 74.3448C66.7489 74.9127 66.5427 75.3849 66.2129 75.7194Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2043 45.3889C66.664 45.3889 66.1112 45.268 65.5632 45.0322L60.433 42.8223C59.1793 42.2823 56.8497 41.9377 55.3645 42.149L50.6725 42.8223C48.0156 43.2089 45.8511 41.2197 45.8511 38.6219L45.8511 35.5185C45.8511 34.3454 46.288 33.2591 47.08 32.4569C47.8719 31.6561 48.9402 31.217 50.0905 31.217C50.2728 31.217 50.4596 31.2277 50.6478 31.2513L57.1258 32.049C59.0002 32.2786 61.7822 33.1397 63.4557 34.0056L66.9711 35.8226C68.9781 36.8624 70.553 39.4553 70.553 41.7254C70.553 43.8482 69.1449 45.3889 67.2044 45.3889L67.2043 45.3889Z",
    fill: "#495057"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 81.5 31)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcToggleOff);
export default __webpack_public_path__ + "static/media/ec-toggle-off.379ffa70a5880d074ead300a3dcaed2d.svg";
export { ForwardRef as ReactComponent };